import React from "react";
import ReactSelect from "react-select";
import "./index.css"

const Select = (props: any) => {
    const {
        name = '',
        isMulti = false,
        options = [],
        className = "basic-multi-select",
        classNamePrefix = "select",
        value = '',
        onChange = (e: any) => {},
        placeholder = 'Selecciona',
        disabled = false
    } = props

    return (
        <ReactSelect
            isDisabled={disabled}
            isMulti={isMulti}
            name={name}
            options={options}
            className={className}
            classNamePrefix={classNamePrefix}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
        />
    )
}

export default Select